<div class="modal-backdrop">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ title || 'COMPONENTS.MODALS.CONFIRM.TITLE' | translate }}</h4>
      </div>
      <div class="modal-body">
        <p>{{ message || 'COMPONENTS.MODALS.CONFIRM.MSG' | translate }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" [ap-btn-loading]="loading" class="btn btn-primary" (click)="confirm()" attr.aria-label="{{ 'COMPONENTS.MODALS.CONFIRM.YES'| translate }}">{{ confirmButton || 'COMPONENTS.MODALS.CONFIRM.YES'| translate }}</button>
        <button type="button" [disabled]="loading ? 'disabled': null" class="btn btn-default" (click)="cancel()" attr.aria-label="{{ 'COMPONENTS.MODALS.CONFIRM.CANCEL'| translate }}">{{ closeButton || 'COMPONENTS.MODALS.CONFIRM.CANCEL'| translate }}</button>
      </div>
    </div>
  </div>
</div>
